import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import Button from '../../components/Button';
import styles from '../../styles/forms/add_task_wizard/AddTaskForm.scss';

const SelectPlanningSubstageForm = ({
  handleSubmit, options, stages, selectedStageId, selectedSubstageId, submitting,
  onClose, loading, loadingSubstages, onStageChange, change,
}) => (
  <Form onSubmit={handleSubmit} className={styles.wrapper}>
    <div className={styles.form}>
      <Field
        name='stage_id'
        component={Select}
        label={__('add-timesheet-form.stage')}
        options={stages}
        searchable
        noSort
        disabled={loading || submitting}
        onChange={(event, value) => {
          change('substage_id', null);
          onStageChange(value);
        }}
      />
      <Field
        name='substage_id'
        component={Select}
        label={__('wizard.add-task.substage')}
        options={options}
        searchable
        noSort
        disabled={!selectedStageId || loadingSubstages || submitting}
      />
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={onClose}
        />
        <Button
          lightBlue
          medium
          submit
          middleText={__('button.next')}
          spinning={submitting || loading || loadingSubstages}
          disabled={loading || loadingSubstages || submitting || !selectedStageId || !selectedSubstageId}
        />
      </div>
    </div>
  </Form>
);

export default reduxForm({
  form: 'add_task_from_project_planning.select_substage',
})(SelectPlanningSubstageForm);
